import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FunnelSimple, X } from "@phosphor-icons/react";

const FSelect = ({ label, value, onChange, options, testid, width = "w-44" }) => (
  <div className="flex flex-col gap-1">
    <span className="pf-label">{label}</span>
    <Select value={value || "all"} onValueChange={(v) => onChange(v === "all" ? "" : v)}>
      <SelectTrigger
        data-testid={testid}
        className={`h-9 ${width} rounded-sm border-[#E3E7EC] bg-[#F1F3F6] text-sm text-[#0F172A] focus:ring-[#F0323E]`}
      >
        <SelectValue placeholder="All" />
      </SelectTrigger>
      <SelectContent className="max-h-72 rounded-sm border-[#E3E7EC] bg-[#FFFFFF] text-[#0F172A]">
        <SelectItem value="all">All</SelectItem>
        {options.map((o) => (
          <SelectItem key={o} value={o} className="text-sm">
            {o}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

export const FilterBar = ({ filters, setFilters, options }) => {
  const set = (k) => (v) => setFilters((f) => ({ ...f, [k]: v }));
  const active = Object.values(filters).filter(Boolean).length;

  return (
    <div className="flex flex-wrap items-end gap-3 border border-[#E3E7EC] bg-[#FFFFFF] p-4">
      <div className="mr-1 flex items-center gap-2 self-center text-[#64748B]">
        <FunnelSimple size={16} weight="bold" />
        <span className="pf-label">Filters</span>
      </div>
      <FSelect label="Order Type" value={filters.order_type} onChange={set("order_type")} options={options.order_types || []} testid="filter-order-type" width="w-32" />
      <FSelect label="Buyer" value={filters.buyer} onChange={set("buyer")} options={options.buyers || []} testid="filter-buyer" width="w-52" />
      <FSelect label="Branch / Plant" value={filters.branch} onChange={set("branch")} options={options.branches || []} testid="filter-branch" width="w-44" />
      <FSelect label="Next Status" value={filters.status} onChange={set("status")} options={options.statuses || []} testid="filter-status" width="w-52" />
      {active > 0 && (
        <button
          data-testid="clear-filters"
          onClick={() =>
            setFilters({ order_type: "", buyer: "", branch: "", supplier: "", status: "", date_from: "", date_to: "" })
          }
          className="flex h-9 items-center gap-1 rounded-sm border border-[#CAD1DB] bg-[#F1F3F6] px-3 text-xs font-medium text-[#64748B] transition-colors hover:bg-[#EDEFF3] hover:text-white"
        >
          <X size={14} weight="bold" /> Clear ({active})
        </button>
      )}
    </div>
  );
};
